module.exports = __webpack_public_path__ + "img/steady-phone.bccd2df1.jpg";